<template>
     <div class="wwarningmessages-search">
          <PageTitle 
                icon="fa fa-comments" 
                main="Warning" sub="Message" 
                />
          <b-card class="tenantagreement-search-card">
                    <b-tabs card vertical >
                        <b-tab title="Detail" active>
                        <b-form>
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            :per-page="perPage" 
                            :current-page="currentPageFinancial" 
                            head-variant="light" 
                            :items="warningmessages" 
                            :fields="fielsFinancial">
                              <template v-slot:cell(actions)="data">
                                 <b-button 
                                    title="Read" 
                                    size="sm" 
                                    variant="light" 
                                    @click="[readMessage(data.item)]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-check"></i>
                                </b-button>
                              </template>
                        </b-table>
                        </transition>   
                        <b-pagination
                           v-show="showTable"
                            v-model="currentPageFinancial"
                            :total-rows="rowsFinancial"
                            :per-page="perPage"
                            size="sm"
                            aria-controls="my-table"
                        ></b-pagination>                          
                            </b-row>
                        </b-form>

                        </b-tab >
                    </b-tabs>         
                </b-card>     
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'WarningMessage',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                file: null,
                warningmessage:{},
                warningmessages:[],
                perPage: 20,
                currentPage: 1,
                currentPageFinancial: 1,
                currentPageFinancialSearch: 1,
                 isBusy: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
             
                fielsFinancial:[
                    {
                        key: 'register',label: 'Register',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'complement_message', label: 'Posted by', sortable: false },
                    { key: 'description_message', label: 'Message', sortable: false },
                    { key: 'actions', label: 'Action',variant: 'light' }  
                
                ],
              
                 optionsPayment: [
                    { item: 1, name: 'Cash' },
                    { item: 2, name: 'Bank Transfer' }
                ],
                optionsReceipt: [
                        { text: 'Not received', value: 0 },
                        { text: 'Receipt', value: 1 },
                        { text: 'All', value: 2 }     
                ],
            }
        },
        computed: {
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rowsFinancial() {
                return this.warningmessages.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadMessages(){
                const url = `${baseApiUrl}/warningmessagescompanyopen/${this.compan.id}`
                axios(url).then(res =>{
                     this.warningmessages = res.data
                })
            },
            async readMessage(item) {

                    this.warningmessage = {...item}

                    const method = this.warningmessage.id ? 'put' : 'post'
                    const id = this.warningmessage.id ? `/${this.warningmessage.id}` : ''

                    this.warningmessage.user_id_closed_message = this.user.id

                    await axios[method](
                        `${baseApiUrl}/readwarningmessages${id}`,
                        this.warningmessage
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.warningmessage = {}
                            this.loadMessages()
                 
                        })
                        .catch(showError)
            },
         

        },
        mounted(){
            this.loadMessages()
            this.showTable = true
        }
}
</script>

<style>


    .tenantagreement-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .tenantagreement-search button{
        font-size: 0.75rem;
    }

     .tenantagreement-search select{
        font-size: 0.75rem;
    }

    .tenantagreement-search input{
        font-size: 0.75rem;
    }

    .tenantagreement-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalBank {
        font-size: 0.75rem;
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }

 #modalFinancial {
        font-size: 0.75rem;
    }

    #modalFinancial button{
        font-size: 0.75rem;
    }

     #modalFinancial input{
        font-size: 0.75rem;
    }

      #modalFinancial select{
        font-size: 0.75rem;
    }

      #modalFinancial label{
        font-size: 0.75rem;
        color: black;
    }
    
       #modalFinancial textarea{
            font-size: 0.75rem;
        }



    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
